const userFormSubmissionDBO = (
  formData,
  regionData,
  session,
  optionalQuestionsArray,
) => {
  const optional_answers =
    optionalQuestionsArray &&
    optionalQuestionsArray.reduce((acc, question) => {
      acc[question] = formData[question]
      return acc
    }, {})

  return {
    user_number: session.userDb.user_number,
    user_id: session.user.id || session.userDb.user_id,
    consentAdvertising: formData.consentAdvertising,
    consentCollectPersonalInformation:
      formData.consentCollectPersonalInformation,
    consentMarketing: formData.consentMarketing,
    consentEvent: formData.consentEvent,
    name: formData.name,
    phone_number: formData.phone_number || formData.phoneNumber,
    gender: formData.gender,
    answer1: '',
    answer2: '',
    answer3: '',
    answer4: formData.contact,
    region_cd: regionData.id,
    region_nm_k: regionData.regionNameKr,
    region_nm_e: regionData.value,
    birthday: formData.birthday,
    contact_method: formData.contact || '',
    optional_answers,
  }
}

export default userFormSubmissionDBO
